Devuelve la credencial autenticada y el catálogo global de scopes disponibles en el producto.

<ApiCodeExamples exampleId="metaScopes" />

<ApiResponseExamples exampleId="metaScopes" />

## Campos principales de la respuesta `200`

- `credential`: snapshot actual de la credencial autenticada.
- `credential.scopes`: scopes actualmente asignados a la credencial.
- `credential.allowed_ips`: allowlist efectiva de IPs, cuando exista.
- `credential.rate_limit_per_minute`: límite operativo por minuto de esa credencial.
- `available_scopes`: catálogo global de scopes reconocidos por la plataforma.

Scopes implementados: `campaigns.read`, `calls.read`, `calls.write`, `agents.read`, `scripts.read`, `users.read`, `transfer_groups.read`.

## Cuándo usar este endpoint

- verificar qué scopes tiene realmente la credencial actual;
- comparar el catálogo global con los scopes ya asignados;
- depurar `403 Forbidden` o gaps de permiso en integraciones externas.
